module.exports = __webpack_public_path__ + "img/platform_01_ongezond.de119498.png";